export const SUB_CATEGORY_CODE_MIN_LEN = 3;
export const SUB_CATEGORY_CODE_MAX_LEN = 5;

function normalizeWords(name: string): string[] {
  return name
    .trim()
    .split(/[^a-zA-Z0-9]+/)
    .map((w) => w.replace(/[^a-zA-Z0-9]/g, ''))
    .filter(Boolean);
}

/** Build an uppercase code (3–5 chars) derived from the subcategory name. */
export function buildSubCategoryCodeFromName(name: string): string {
  const words = normalizeWords(name);
  if (!words.length) return '';

  let code: string;
  if (words.length === 1) {
    code = words[0]!.toUpperCase().slice(0, SUB_CATEGORY_CODE_MAX_LEN);
  } else {
    code = words.map((w) => w[0]!.toUpperCase()).join('');
    if (code.length < SUB_CATEGORY_CODE_MIN_LEN) {
      const first = words[0]!.toUpperCase();
      for (let i = 1; i < first.length && code.length < SUB_CATEGORY_CODE_MAX_LEN; i++) {
        code += first[i]!;
      }
    }
    code = code.slice(0, SUB_CATEGORY_CODE_MAX_LEN);
  }

  return code.toUpperCase();
}

export function normalizeSubCategoryCodeInput(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, SUB_CATEGORY_CODE_MAX_LEN);
}

export function isValidSubCategoryCode(code: string): boolean {
  const c = code.trim().toUpperCase();
  return new RegExp(`^[A-Z0-9]{${SUB_CATEGORY_CODE_MIN_LEN},${SUB_CATEGORY_CODE_MAX_LEN}}$`).test(c);
}
